import React, { useState } from 'react';
import { analyticsManager } from '../index';

const ImageContainer = ({ 
  src, 
  alt, 
  height = 400, 
  variant = 'default', // 'default', 'clean'
  delay = 400,
  videoSrc = null, // si fourni, affiche un bouton play qui remplace l'image par la vidéo
  videoWidth = null, // largeur fixe de la vidéo (Safari ne sait pas dimensionner une vidéo en width:auto avant le chargement des métadonnées)
  videoAnalyticsOrigin = null // origine envoyée aux analytics lors de la lecture de la vidéo
}) => {
  const [playing, setPlaying] = useState(false);

  const logVideoEvent = (playOverEnded) => {
    if (videoAnalyticsOrigin) {
      analyticsManager.logHPVideoTag(videoAnalyticsOrigin, playOverEnded);
    }
  };

  const getContainerStyles = () => {
    const baseStyles = {
      backgroundColor: 'transparent',
      borderRadius: '20px',
      padding: '0',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden',
      transformOrigin: 'center center',
      // Fix Safari sizing in flex containers by setting explicit height
      height: height,
      flexShrink: 0
    };

    if (variant === 'clean') {
      return {
        ...baseStyles,
        boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)'
      };
    }

    return baseStyles;
  };

  const getImageStyles = () => {
    return {
      // Let image fill container height reliably on Safari
      height: '100%',
      borderRadius: '20px',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.3s ease',
      width: 'auto',
      objectFit: 'cover',
      display: 'block'
    };
  };

  return (
    <div 
      className={`scroll-fade-right scroll-delay-${delay}`}
      style={{ marginLeft: '0' }}
    >
      <div 
        className="scroll-image-container"
        style={getContainerStyles()}
      >
        {videoSrc && playing ? (
          <video
            src={videoSrc}
            controls
            controlsList="nofullscreen"
            disablePictureInPicture
            autoPlay
            playsInline
            onEnded={() => { logVideoEvent(false); setPlaying(false); }}
            style={{
              ...getImageStyles(),
              width: videoWidth != null ? videoWidth : 'auto',
              backgroundColor: '#000000',
            }}
          />
        ) : (
          <>
            <img 
              alt={alt} 
              src={src} 
              style={getImageStyles()}
            />
            {videoSrc && (
              <button
                type="button"
                aria-label="Play video"
                onClick={() => { logVideoEvent(true); setPlaying(true); }}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: 72,
                  height: 72,
                  borderRadius: '50%',
                  border: 'none',
                  backgroundColor: 'rgba(0, 0, 0, 0.55)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'background-color 120ms ease, transform 120ms ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.75)'; e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.55)'; e.currentTarget.style.transform = 'translate(-50%, -50%)'; }}
              >
                <div style={{
                  width: 0,
                  height: 0,
                  marginLeft: 6,
                  borderTop: '14px solid transparent',
                  borderBottom: '14px solid transparent',
                  borderLeft: '22px solid #ffffff',
                }} />
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ImageContainer;
